import { Component, } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SideNavService } from 'src/app/core-flc/sidenav/sidenav.service';
import { RouterLinkEnum } from 'src/app/enums/router-link-enum';
import { SysParamControllerService } from 'src/app/server-api/services';
import { ListComponent } from 'src/app/utils-flc/list/list.component';

@Component({
  selector: 'app-system-params-list',
  templateUrl: './system-params-list.component.html',
  styleUrls: ['./system-params-list.component.css']
})
export class SystemParamsListComponent extends ListComponent {

  constructor(public override translate: TranslateService, public override sidenavService: SideNavService, private systParamsService: SysParamControllerService) {
      super(translate, sidenavService);

      translate
      .get(['system-params.button_create', 'icon_refresh', 'action_show'
    ])
      .subscribe((translations: string) => {
        this.topMenuIcons = [
          {icon: "add", title: translations['system-params.button_create'], routerLink: RouterLinkEnum.SYSTEMPARAMS.toString() + "new", clickMethod: "dummy"},
          {icon: "refresh", title: translations['icon_refresh'], routerLink: null, clickMethod: "refresh"}
        ];
        this.actions = [
          {icon: "playlist_add", title: translations['action_show'], routerLink: RouterLinkEnum.SYSTEMPARAMS.toString(), clickMethod: "dummy"}
        ];
      });
      this.constructorName = 'SystemParamsList';
    }

  override ngOnInit(): void {

    this.placeholderSearchText = 'system-params.search';
    this.exportPrefix = 'system-params_';
    this.primarySort.active = 'key';
    this.defaultSort.active = 'key';

    super.ngOnInit();

    this.displayedColumns = ['actions', 'key', 'value'];
  }

  override getItems() {
    super.getItems();
    this.systParamsService.getSysParams({ page: this.paginator.pageIndex, size: this.paginator.pageSize, sort: [this.dataSource.sort.active + ',' + this.dataSource.sort.direction], filter: this.filter.nativeElement.value }).subscribe(
      value  => {
        this.dataSource.data = value['content'];
        this.listIds = this.dataSource.data.map(d => d.id);
        this.totalElements = value['totalElements'];
        this.sidenavService.setLoading(false);
      }
    ,
      error => {
        console.error(JSON.stringify(error));
        this.sidenavService.setLoading(false);
      }
        ,
      () => {
        console.log('done ' + this.dataSource.data.length);
        this.sidenavService.setLoading(false);
      }
    );
  }

}


